import { NgModule } from '@angular/core';
import { NbMenuModule, NbIconModule, NbActionsModule } from '@nebular/theme';

import { ThemeModule } from '../@theme/theme.module';
import { PagesComponent } from './pages.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { ECommerceModule } from './e-commerce/e-commerce.module';
import { PagesRoutingModule } from './pages-routing.module';
import { MiscellaneousModule } from './miscellaneous/miscellaneous.module';
import { ShareModule } from '../shared/share.module';
import { HorsideRoutingModule } from '../horside-routing.module';
import { CmsPagesModule } from './cmspages/cmspages.module';
import { ArticlesModule } from './articles/articles.module';
import { SettingsModule } from './settings/settings.module';
import { CategoriesModule } from './category/categories.module';
import { MenusModule } from './menu/menus.module';
import { ProjetsModule } from './projet/projets.module';
import { SouscriptionsModule } from './souscription/souscriptions.module';
import { UsersModule } from './users/users.module';
import { MessagesModule } from './messages/messages.module';
import { EcoleModule } from './ecoles/ecole.module';
import { FormationsModule } from './formations/formations.module';
import { CriteresModule } from './criteres/criteres.module';
import { EditCritereComponent } from './criteres/edit-critere/edit-critere.component';
import { MetiersModule } from './metiers/metiers.module';
import { JobsModule } from './jobs/jobs.module';
import { LicenceKeyModule } from './licencekey/licencekey.module';
import { DeviceModule } from './device/device.module';
import { DatabaseModule } from './database/database.module';
import { OffreModule } from './offre/offre.module';

@NgModule({
  imports: [
    HorsideRoutingModule,
    PagesRoutingModule,
    ThemeModule,
    NbMenuModule,
    DashboardModule,
    ECommerceModule,
    MiscellaneousModule,
    NbIconModule,
    NbActionsModule,
    ShareModule,
    CmsPagesModule,
    ArticlesModule,
    SettingsModule,
    CategoriesModule,
    MenusModule,
    ProjetsModule,
    SouscriptionsModule,
    UsersModule,
    MessagesModule,
    EcoleModule,
    FormationsModule,
    CriteresModule,
    MetiersModule,
    JobsModule,
    LicenceKeyModule,
    DatabaseModule,
    DeviceModule,
    OffreModule,
  ],
  entryComponents: [
    EditCritereComponent,
  ],
  declarations: [
    PagesComponent,
    EditCritereComponent,
  ],
})
export class PagesModule {
}
